var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("exhibitor-navbar", {
        staticClass: "mb-1",
        attrs: {
          filter: _vm.filter,
          "fav-key": "sfid",
          "fav-mode": _vm.favoriteMode,
          "visits-active": _vm.visitsActive,
          "num-visits": _vm.numVisitedExhibitors,
        },
        on: {
          search: function ($event) {
            return _vm.onSearchChanged($event)
          },
          "delete-search": function ($event) {
            return _vm.resetFilter()
          },
          "on-filter-value": function ($event) {
            return _vm.onFilterValue($event)
          },
          "toggle-favorites": function ($event) {
            return _vm.toggleFavorites($event)
          },
          "toggle-visits": function ($event) {
            return _vm.toggleVisits($event)
          },
          "export-list": function ($event) {
            return _vm.exportList()
          },
        },
      }),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb bg-white ps-0" }, [
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.numFavorites) +
              " Favoriten / " +
              _vm._s(_vm.numVisitedExhibitors) +
              " Standbesuche / " +
              _vm._s(_vm.numExhibitors) +
              " Treffer\n    "
          ),
        ]),
        _vm._v(" "),
        this.filter.company__name__gt
          ? _c("li", { staticClass: "breadcrumb-item active" }, [
              _c(
                "a",
                {
                  staticClass: "badge badge-pill bg-light me-1",
                  staticStyle: { "text-decoration": "none" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onFilterValue()
                    },
                  },
                },
                [
                  _c("b", [
                    _vm._v(_vm._s(this.filter.company__name__gt) + " "),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "far fa-times-circle" }),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.favActive
          ? _c("li", { staticClass: "breadcrumb-item active" }, [
              _c(
                "a",
                {
                  staticClass: "badge badge-pill bg-warning me-1",
                  staticStyle: { "text-decoration": "none" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.toggleFavorites()
                    },
                  },
                },
                [
                  _c("b", [_vm._v("Favoriten ")]),
                  _vm._v(" "),
                  _c("i", { staticClass: "far fa-times-circle" }),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.visitsActive
          ? _c("li", { staticClass: "breadcrumb-item active" }, [
              _c(
                "a",
                {
                  staticClass: "badge badge-pill bg-warning me-1",
                  staticStyle: { "text-decoration": "none" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.toggleVisits()
                    },
                  },
                },
                [
                  _c("b", [_vm._v("Standbesuche ")]),
                  _vm._v(" "),
                  _c("i", { staticClass: "far fa-times-circle" }),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.exhibitors.length > 0
        ? _c(
            "span",
            [
              _vm._l(_vm.exhibitors, function (exhibitor) {
                return _c(
                  "div",
                  { key: exhibitor.id },
                  [
                    _c("exhibitor-row", {
                      attrs: {
                        exhibitorType: _vm.exhibitorType,
                        exhibitor: exhibitor,
                        listDisplay: _vm.listDisplay,
                      },
                      on: { "favorite-changed": _vm.getFavorites },
                    }),
                    _vm._v(" "),
                    _c("hr"),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "py-3 text-center" }, [
                _c("button", { attrs: { disabled: _vm.page == 1 } }, [
                  _c("i", {
                    staticClass: "fas fa-chevron-left",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.previousPage()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mx-3" }, [
                  _vm._v(_vm._s(_vm.page) + " / " + _vm._s(_vm.numPages)),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  { attrs: { disabled: _vm.page == _vm.numPages } },
                  [
                    _c("i", {
                      staticClass: "fas fa-chevron-right",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.nextPage()
                        },
                      },
                    }),
                  ]
                ),
              ]),
            ],
            2
          )
        : _c("div", { staticClass: "mb-3" }, [
            _c("div", { staticClass: "text-center" }, [
              _vm._v("-- keine Treffer --"),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }